export function demostrative(text) {
    return `


<div class=WordSection1>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt'><b><span
style='font-size:24.0pt;font-family:"Zilla Slab",serif;color:black;letter-spacing:
.75pt'>Demonstrative adjectives - Easy Learning Grammar Spanish</span></b></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt'><b><span
style='font-size:24.0pt;font-family:"Zilla Slab",serif;color:black;letter-spacing:
.75pt'>&nbsp;</span></b></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>What is a demonstrative adjective?</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'><br>
</span><span style='font-size:12.0pt;font-family:"Open Sans",sans-serif;
color:black'>A&nbsp;</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>demonstrative adjective</span></b><span style='font-size:12.0pt;
font-family:"Open Sans",sans-serif;color:black'>&nbsp;is one of the words&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>this, that,
these</span></i><span style='font-size:12.0pt;font-family:"Open Sans",sans-serif;
color:black'>&nbsp;and&nbsp;</span><i><span style='font-size:12.0pt;font-family:
"inherit",serif;color:black'>those</span></i><span style='font-size:12.0pt;
font-family:"Open Sans",sans-serif;color:black'>&nbsp;used with a noun in
English to point out a particular thing or person, for example,&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>this</span></i><span
style='font-size:12.0pt;font-family:"Open Sans",sans-serif;color:black'>&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>woman</span></i><span
style='font-size:12.0pt;font-family:"Open Sans",sans-serif;color:black'>,&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>that</span></i><span
style='font-size:12.0pt;font-family:"Open Sans",sans-serif;color:black'>&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>dog</span></i><span
style='font-size:12.0pt;font-family:"Open Sans",sans-serif;color:black'>.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
color:black'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
color:black'>1&nbsp;&nbsp;&nbsp;Using demonstrative adjectives</span></u></b></p>

<p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Just as in English, Spanish demonstrative adjectives go&nbsp;BEFORE&nbsp;the
noun. Like other adjectives in Spanish, they have to change for the feminine
and plural forms.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'></td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Masculine</span></b></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Feminine</span></b></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Meaning</span></b></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Singular</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>este</span></b><span
  style='font-size:12.0pt;font-family:"inherit",serif'><br>
  <b>ese</b><br>
  <b>aquel</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>esta</span></b><span
  style='font-size:12.0pt;font-family:"inherit",serif'><br>
  <b>esa</b><br>
  <b>aquella</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>this<br>
  that (<i>close by</i>)<br>
  that (<i>further away</i>)</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Plural</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>estos</span></b><span
  style='font-size:12.0pt;font-family:"inherit",serif'><br>
  <b>esos</b><br>
  <b>aquellos</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>estas</span></b><span
  style='font-size:12.0pt;font-family:"inherit",serif'><br>
  <b>esas</b><br>
  <b>aquellas</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>these<br>
  those (<i>close by</i>)<br>
  those (<i>further away</i>)</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Use&nbsp;<b>este</b>/<b>esta</b>/<b>estos</b>/<b>estas</b>&nbsp;(meaning&nbsp;<i>this</i>/<i>these)</i>&nbsp;to
talk about things and people that are near&nbsp;you.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Este</span></b><span
  style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>bolígrafo no
  escribe.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>This pen
  isn’t working.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Me
  he comprado</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
  "inherit",serif'>&nbsp;<b>estos</b>&nbsp;<b>libros.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I’ve
  bought these books.</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Use&nbsp;<b>ese</b>/<b>esa</b>/<b>esos</b>/<b>esas</b>&nbsp;and&nbsp;<b>aquel</b>/<b>aquella</b>/<b>aquellos</b>/<b>aquellas</b>&nbsp;(meaning&nbsp;<i>that/those)</i>&nbsp;to
talk about things that are further away.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Esa</span></b><span
  lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>revista
  es muy mala.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>That
  magazine is very bad.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>&iquest;Conoces
  a</span></b><span style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>esos</b>&nbsp;<b>se&ntilde;ores?</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Do you
  know those gentlemen?</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>No
  le gusta</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>aquella</b>&nbsp;<b>mu&ntilde;eca.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>She
  doesn’t like that doll.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Siga
  usted hasta</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
  "inherit",serif'>&nbsp;<b>aquellos&nbsp;árboles.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Carry on
  until you reach those trees (over there).</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
color:black'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
color:black'>2&nbsp;&nbsp;&nbsp;ese or aquel?</span></u></b></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>In English we use&nbsp;<i>that</i>&nbsp;and&nbsp;<i>those</i>&nbsp;to
talk about anything that is not close by, but in Spanish you need to be a bit
more precise.</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:white'><span lang=ES-MX style='font-size:10.0pt;font-family:Symbol;
color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Use&nbsp;<b>ese</b>/<b>esa</b>/<b>esos</b>/<b>esas</b>:</span></p>

<p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>to talk about things and people that are nearer to the person you
are talking to than to you</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>ese</span></b><span
  lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>papel
  en el que escribes</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>that paper
  you’re writing on</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&iquest;Por
  qué te has puesto</span></b><span lang=ES-MX style='font-size:12.0pt;
  font-family:"inherit",serif'>&nbsp;<b>esas&nbsp;medias?</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Why are
  you wearing those tights?</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>to talk about things and people that aren’t very far away</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>No
  me gustan</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
  "inherit",serif'>&nbsp;<b>esos</b>&nbsp;<b>cuadros.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I don’t
  like those pictures.</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Use&nbsp;<b>aquel</b>/<b>aquella</b>/<b>aquellos</b>/<b>aquellas</b>&nbsp;to
talk about things that are further away</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Me
  gusta más</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
  "inherit",serif'>&nbsp;<b>aquella</b>&nbsp;<b>mesa.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I prefer
  that table (over there).</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='line-height:normal;background:white'><span
style='font-size:13.5pt;font-family:"inherit",serif;color:black'>Grammar
Extra!You should use&nbsp;<b>ese</b>/<b>esa</b>/<b>esos</b>/<b>esas</b>&nbsp;when
you are talking about a definite date, month or year.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&iquest;1999?
  No me acuerdo de dónde pasamos las vacaciones</span></b><span lang=ES-MX
  style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>ese&nbsp;a&ntilde;o.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>1999? I
  can’t remember where we went on holiday that year.</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='line-height:normal;background:white'><span
style='font-size:13.5pt;font-family:"inherit",serif;color:black'>You should
use&nbsp;<b>aquel</b>/<b>aquella</b>/<b>aquellos</b>/<b>aquellas</b>&nbsp;when
you are talking about something in the past and not mentioning a definite date.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>aquellas</span></b><span
  lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>vacaciones
  que pasamos en Francia</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>those
  holidays we had in France</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal;background:#E1E4EE'><span style='font-size:13.5pt;font-family:"inherit",serif;
color:black'>Key points</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>this</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;+ noun =&nbsp;</span><b><span style='font-size:12.0pt;
font-family:"inherit",serif;color:black'>este</span></b><span style='font-size:
12.0pt;font-family:"inherit",serif;color:#B71533'>/</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>esta</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;+ noun</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>these</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;+ noun =&nbsp;</span><b><span style='font-size:12.0pt;
font-family:"inherit",serif;color:black'>estos</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>/</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>estas</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;+ noun</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>that</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;+ noun =&nbsp;</span><b><span style='font-size:12.0pt;
font-family:"inherit",serif;color:black'>ese</span></b><span style='font-size:
12.0pt;font-family:"inherit",serif;color:#B71533'>/</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>esa</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;+ noun
(</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>when the object is not far away from you or the person you’re
talking to</span></i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>)</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>that</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;+ noun =&nbsp;</span><b><span style='font-size:12.0pt;
font-family:"inherit",serif;color:black'>aquel</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>/</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>aquella</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;+ noun
(</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>when the object is more distant</span></i><span style='font-size:
12.0pt;font-family:"inherit",serif;color:#B71533'>)</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>those</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;+ noun =&nbsp;</span><b><span style='font-size:12.0pt;
font-family:"inherit",serif;color:black'>esos</span></b><span style='font-size:
12.0pt;font-family:"inherit",serif;color:#B71533'>/</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>esas</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;+ noun
(</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>when the objects are not far away from you or the person you’re
talking to</span></i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>)</span></p>

<p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
normal;background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>those</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;+ noun =&nbsp;</span><b><span style='font-size:12.0pt;
font-family:"inherit",serif;color:black'>aquellos</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>/</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>aquellas</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;+ noun
(</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>when the objects are more distant</span></i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>)</span></p>

<p class=MsoNormal>&nbsp;</p>

</div>

`;
}
